
<template>
  <div class="detail_box">
    <div class="bg"></div>
    <div class="item pd">
      {{name}}是一个互联网贷款推介平台，上线产品均为金融类合规产品，平台本身不作为放款方参与放款、催收环节，望知晓。</div>
    <div class="item">
      为全面贯彻《互联网金融逾期债务催收自律公约（试行）》，构建文明借贷平台，自今日起，针对入驻商户执行平台监管政策，严厉打击一切暴力催收行为。
    </div>
    <!-- <div class="item">
      为响应《催收自律公约》，望广大用户诚信借款，如被暴力催收，请保存证据（<span class="red">电话录音，聊天记录等等</span>），并立即向<span class="red">本平台</span>投诉反馈。
    </div> -->
    <!-- <div class="item">
      另如若发现本平台入驻商户中有<span class="blod">714</span>产品或<span class="blod">套路贷</span>产品，欢迎向<span class="red">本平台客服</span>投诉反馈，并且提供相应<span class="red">截图证据</span>，本平台将第一时间进行下架处理。
    </div> -->
    <!-- <div class="item">
      望用户诚信借款，商户合规放贷，互相尊重，共同建立文明网络借贷环境！
    </div> -->
    <div class="item red">
      温馨提示：本平台将竭力保护用户信息安全，贷款过程中遇到任何预先收费均为诈骗行为，请保持警惕避免损失。其次，本平台参与不放款，也不会通过任何方式主动联系用户放款。不要相信私人放款的信息，常见的诈骗行为：个人支付宝转账、微信转账、有偿提高芝麻信用分、借款先付前期利息等。请提高安全防范意识，明辨真伪，谨防被骗。
      <span @click="statement">点击查看《免责申明》</span>
    </div>
    <div class="right">
      {{name}}<br>
      2019年6月20日
    </div>
    <div class="btn"
         @click="toHelp">联系客服</div>
  </div>
</template>

<script>

export default {
  components: {
    // Head,
  },
  data () {
    return {
      type: '1',
      name: '小额速借'
    }
  },
  mounted () {
    this.util.title('抵制暴力催收 建立文明网贷平台');
    this.type = this.$route.query.type;
    if (this.type == 2) {
      this.name = "大鹅分期"
    } else if (this.type == 3) {
      this.name = "分期借"
    } else if (this.type == 4) {
      this.name = "乐借贷款"
    }
    // (function (w, d, n, a, j) {
    //   w[n] = w[n] || function () {
    //     (w[n].a = w[n].a || []).push(arguments);
    //   };
    //   j = d.createElement('script');
    //   j.async = true;
    //   j.src = 'https://qiyukf.com/client?k=3f9a2096a3b5dc05c7525429aab70eda&wp=1';
    //   d.body.appendChild(j);
    // })(window, document, 'ysf');
  },
  methods: {
    toHelp () {
      window.location.href = "https://qiyukf.com/client?k=3f9a2096a3b5dc05c7525429aab70eda&wp=1"
    },
    statement () {
      window.location.href = "https://thread.yanhugame.com/agreement/statement.html";
    }
  }
}
</script>
<style >
#YSF-CUSTOM-ENTRY-1 {
  background: #ffff00;
}
</style>
<style scoped>
.detail_box {
  background: #fff;
  width: 100%;
  height: 100%;
}
.bg {
  background: #f7f7f7;
  height: 0.1rem;
  width: 100%;
}
.item {
  text-indent: 35px;
  font-size: 0.14rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 26px;
  padding: 0rem 0.19rem;
}
.pd {
  padding-top: 0.1rem;
}
.right {
  font-size: 0.14rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  margin-top: 0.4rem;
  padding-right: 0.19rem;
  text-align: right;
}
.btn {
  clear: both;
  width: 85%;
  height: 0.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 25px;
  border: 1px solid rgba(151, 151, 151, 0.21);
  font-size: 0.15rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(79, 140, 250, 1);
  text-align: center;
  line-height: 0.5rem;
  margin: 0 auto;
  position: relative;
  top: 0.3rem;
  margin-bottom: 0.4rem;
}
.red {
  font-family: PingFangSC;
  color: #ff514a;
  font-weight: 500;
}
.blod {
  font-family: PingFangSC;
  font-weight: 500;
}
</style>
